var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c(
        "form",
        {
          attrs: {
            autocomplete: "off",
            method: "post",
            "data-vv-scope": "form",
          },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return (() => {}).apply(null, arguments)
            },
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onBeforeSaveItem.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-sm-auto" }, [
              _c("h1", { staticClass: "content-title" }, [
                _vm._v(_vm._s(_vm.titleItem)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-9" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:3",
                          expression: "'required|min:3'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-name",
                        name: "name",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("name") },
                        ],
                        error: _vm.fnFirstError("name"),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.name",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-status",
                        name: "status",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.onoff,
                        reduce: (option) => option.code,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("status") },
                        ],
                        error: _vm.fnFirstError("status"),
                      },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "status",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.status`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.lists.channels.length
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "city-label" }, [
                      _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.channel_id`))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap",
                      },
                      _vm._l(_vm.lists.channels, function (channel) {
                        return _c(
                          "div",
                          {
                            key: `channel-${channel.id}`,
                            staticClass: "form-check city-form-check",
                            class: [
                              { "is-invalid": _vm.fnHasError(`channel`) },
                            ],
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.channel_id,
                                  expression: "form.channel_id",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required: true}",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                disabled: _vm.readonlyFormItem,
                                id: `cb-channel-${channel.id}`,
                                name: `channel`,
                              },
                              domProps: {
                                value: channel.id,
                                checked: _vm._q(
                                  _vm.form.channel_id,
                                  channel.id
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "channel_id",
                                    channel.id
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: `cb-channel-${channel.id}` },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(channel.name) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "city-label" }, [
                  _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.targets`))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap",
                  },
                  _vm._l(_vm.lists.targets, function (target) {
                    return _c(
                      "div",
                      {
                        key: `target-${target.id}`,
                        staticClass: "form-check city-form-check",
                        class: [{ "is-invalid": _vm.fnHasError(`targets`) }],
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.targets,
                              expression: "form.targets",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.isAutomatic },
                              expression: "{required: isAutomatic}",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.readonlyFormItem,
                            id: `cb-target-${target.id}`,
                            name: `targets`,
                          },
                          domProps: {
                            value: target,
                            checked: Array.isArray(_vm.form.targets)
                              ? _vm._i(_vm.form.targets, target) > -1
                              : _vm.form.targets,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.form.targets,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = target,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form,
                                      "targets",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form,
                                      "targets",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form, "targets", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: `cb-target-${target.id}` },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(target.name) +
                                "\n                                "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-automatic",
                        name: "automatic",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.onoff,
                        reduce: (option) => option.code,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("automatic") },
                        ],
                        error: _vm.fnFirstError("automatic"),
                      },
                      model: {
                        value: _vm.form.automatic,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "automatic",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.automatic",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.automatic`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-9" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.getRule("subject"),
                          expression: "getRule('subject')",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-subject",
                        name: "subject",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("subject") },
                        ],
                        error: _vm.fnFirstError("subject"),
                      },
                      model: {
                        value: _vm.form.subject,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "subject",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.subject",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.subject`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.isAutomatic
              ? _c("div", { staticClass: "col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.isAutomatic },
                              expression: "{required: isAutomatic}",
                            },
                          ],
                          staticClass: "city-form-group city-bg my-0",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-triggers",
                            name: "triggers",
                            label: "name",
                            filterable: false,
                            options: _vm.lists.triggers,
                            reduceObject: true,
                            multiple: true,
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("triggers") },
                            ],
                            error: _vm.fnFirstError("triggers"),
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.form.triggers,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "triggers",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.triggers",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(`${_vm.pageID}.model.triggers`)) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "city-label" }, [
                    _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.message`))),
                  ]),
                  _vm._v(" "),
                  _vm.readonlyFormItem
                    ? [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.form.message) },
                        }),
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "city-form-group",
                            class: { "is-invalid": _vm.fnHasError("message") },
                          },
                          [
                            _c("ckeditor", {
                              attrs: {
                                disabled: _vm.readonlyFormItem,
                                editor: _vm.cKEditor.editor,
                                config: _vm.cKEditor.editorConfig,
                              },
                              model: {
                                value: _vm.form.message,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "message", $$v)
                                },
                                expression: "form.message",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.message,
                                  expression: "form.message",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.getRule("message"),
                                  expression: "getRule('message')",
                                },
                              ],
                              attrs: { type: "hidden", name: "message" },
                              domProps: { value: _vm.form.message },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "message",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.fnFirstError("message")
                              ? _c(
                                  "small",
                                  { staticClass: "d-block invalid-feedback" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.fnFirstError("message")) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("help-span", {
                              attrs: { helpText: _vm.txtHelpTextMessage },
                            }),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          !_vm.readonlyFormItem
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("p", { staticClass: "city-label" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-main btn-rounded z-depth-0 m-0 collapsed",
                          attrs: {
                            "data-toggle": "collapse",
                            href: "#collapseTags",
                            role: "button",
                            "aria-expanded": "false",
                            "aria-controls": "collapseTags",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t(`${_vm.pageID}.model.tags`)) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse",
                        attrs: { id: "collapseTags" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.lists.tags, function (tag) {
                            return _c(
                              "div",
                              { key: `tag-${tag.id}`, staticClass: "col" },
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("p", {
                                    staticClass: "tag cursor-pointer mb-0",
                                    attrs: {
                                      "data-toggle": "tooltip-city",
                                      "data-placement": "bottom",
                                      title: _vm.txtTitleCopyTag,
                                    },
                                    domProps: {
                                      textContent: _vm._s(
                                        "{{" + tag.name + "}}"
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.copyToClipboard(
                                          $event,
                                          "{{" + tag.name + "}}"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(tag.descr) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("buttons-footer", {
            attrs: {
              enableButtons: !_vm.readonlyFormItem,
              cancelTitle: _vm.cancelTitle,
              submitTitle: _vm.submitTitle,
              isDisabled: _vm.isDisabled,
            },
            on: {
              save: _vm.onBeforeSaveItem,
              cancel: function ($event) {
                return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`, true)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }